// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Tp9esmEOI2U5OlwFuCpPi","cancelBtn":"_37x9omOyJ366COUULKraMb","icon":"_2aI-kO5JOGumLPYNJ8RtMr","saveBtn":"wyfdd7xKLuh90tEuhQ2Rg"};